export enum APPOINTMENT_TYPE {
  CHECKUP = 'checkup',
  CHEMOTHERAPIES='chemotherapies',
  CONSULTATIONS='consultations',
  EXAMS='exams',
  NEW_APPOITMENT='new-appointment',
  REQUEST='request',
  RESCHEDULE='reschedule',
  SERVICES='services',
  SURGERIES='surgeries',
  UNKNOW = '',
  WAITING_LIST = 'waitinglist',
}
